import { lb } from "../../../../date-fns/locale/lb.js";
window.dateFns = {
  ...window.dateFns,
  locale: {
    ...window.dateFns?.locale,
    lb
  }
};